import { Control } from "../../business-objects/control/control.model";
import { RichTextControlConfig } from "./rich-text-control-config.model";

export class RichTextControl extends Control {
    config: RichTextControlConfig;
}



// WEBPACK FOOTER //
// ./src/vas/controls/rich-text/rich-text-control.model.ts